import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { BFormCheckbox } from "bootstrap-vue";
import {} from "@/api/notifications";
import MessageNotification from "./Categories/MessageNotification.vue";
import SharedItemNotification from "./Categories/SharedItemNotification.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationCard',
    props: {
        selected: { type: Boolean },
        selectable: { type: Boolean },
        unreadBorder: { type: Boolean },
        notification: null
    },
    emits: ["select"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCircle);
        return { __sfc: true, props, emit, BFormCheckbox, MessageNotification, SharedItemNotification };
    }
});
